import {Injectable} from '@angular/core';
import * as _ from 'lodash-es';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {getTimeframeSettingByCandleSize} from '../../../components/trading-view-chart';
import {formatSecurityKey, parseSecurityKey} from '../../../models/security-key';
import {AppConfigService} from '../../../services/config.service';
import {CHART_WIDGET_SETTINGS_VERSION, ChartWidgetSettings, ChartWidgetSettingsDef} from './chart-widget-settings';

@Injectable()
export class ChartWidgetSettingsService implements WidgetSettingsService {

    private defaultSettingsDef: ChartWidgetSettingsDef = {
        version:               CHART_WIDGET_SETTINGS_VERSION,
        title:                 null,
        securityKeyStr:        this.appConfigService.appConfig.defaultSecurityKey,
        candleSize:            '5',
        isConfirmationEnabled: true,
        chartState:            {},
        visibleTimeRange:      undefined
    };

    constructor(
        private appConfigService: AppConfigService
    ) {}

    public getDefaultSettings(): Observable<ChartWidgetSettings> {
        return this.fromDefinition(this.defaultSettingsDef);
    }

    public fromDefinition(settingsDef: ChartWidgetSettingsDef): Observable<ChartWidgetSettings> {
        settingsDef = this.migrateSettingsVersion(settingsDef)
            || this.defaultSettingsDef;

        const candleSize = getTimeframeSettingByCandleSize(settingsDef.candleSize)
            ? settingsDef.candleSize
            : this.defaultSettingsDef.candleSize;

        return of<ChartWidgetSettings>({
            candleSize,
            title:                 settingsDef.title,
            securityKey:           parseSecurityKey(
                settingsDef.securityKeyStr
                || this.defaultSettingsDef.securityKeyStr
            ),
            isConfirmationEnabled: settingsDef.isConfirmationEnabled,
            chartState:            _.cloneDeep(settingsDef.chartState || this.defaultSettingsDef.chartState),
            visibleTimeRange:      settingsDef.visibleTimeRange
                                       && settingsDef.visibleTimeRange.slice() as [number, number],
            keepVisibleTimeRange:  !!settingsDef.keepVisibleTimeRange
        });
    }

    public toDefinition(settings: ChartWidgetSettings): ChartWidgetSettingsDef {
        return settings && {
            version:               CHART_WIDGET_SETTINGS_VERSION,
            candleSize:            settings.candleSize,
            title:                 settings.title,
            securityKeyStr:        formatSecurityKey(settings.securityKey),
            isConfirmationEnabled: settings.isConfirmationEnabled,
            chartState:            _.cloneDeep(settings.chartState),
            visibleTimeRange:      settings.visibleTimeRange
                                       && settings.visibleTimeRange.slice() as [number, number],
            keepVisibleTimeRange:  settings.keepVisibleTimeRange
        };
    }

    private migrateSettingsVersion(settingsDef: ChartWidgetSettingsDef): ChartWidgetSettingsDef {
        return !settingsDef || settingsDef.version === CHART_WIDGET_SETTINGS_VERSION
            ? settingsDef
            : !settingsDef.version
                ? {
                    ...settingsDef,
                    version:    CHART_WIDGET_SETTINGS_VERSION,
                    chartState: this.defaultSettingsDef.chartState
                }
                : undefined;
    }

}
